import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-termo-list',
  templateUrl: './termo-list.component.html',
  styleUrls: ['./termo-list.component.css']
})
export class TermoListComponent implements OnInit {

 
  @Input()
  termo:string[]
 
  paginas: SafeResourceUrl[] = []
  type:string;

  TYPE_PDF =  'application/pdf'; 
  TYPE_PNG =  'image/png';
  TYPE_JPG =  'image/jpg';

  private _signatures = this.buildSignatures();


  constructor(private _sanitizer: DomSanitizer) { }

  ngOnInit() {
   this.showTermo();
    
  }

  showTermo(){
    for (const pagina of this.termo){
      let content =  pagina;
      this.type = this.extractMineType(pagina);

      if(this.type === null){
        this.type = this.detectMimeType(pagina);
        content = this.buildContent(pagina);
      }
      this.paginas.push(this._sanitizer.bypassSecurityTrustResourceUrl(content))
    }
  }

   detectMimeType(base64):string {
    for (var signature in this._signatures) {
      if (base64.indexOf(signature) === 0) {
        return this._signatures[signature];
      }
    }
  }

  buildContent(base64){
    if(this.type === this.TYPE_PDF){
      return this.setDataTypeBase64(base64, this.TYPE_PDF);
    }else if(this.type === this.TYPE_JPG){
      return this.setDataTypeBase64(base64, this.TYPE_JPG);
    }else {
      return this.setDataTypeBase64(base64, this.TYPE_PNG);
    }
  }

  setDataTypeBase64(base64:string, type:string){
    return `data:${type};base64,${base64}`;
  }

  extractMineType(base64):string{
    const mime = base64.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

    return mime && mime.length ? mime[1]  : null;
  }
  
  buildSignatures():object{
    return {
      JVBERi0: this.TYPE_PDF,
      iVBORw0KGgo: this.TYPE_PNG,
      "/9j/": this.TYPE_JPG
    };
  }
}
